import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimeKeeperDeviceState {
  id: any;
  timeKeeperSystemTypeId: any;
  name: any;
  channel: any;
  type: any;
  timeKeeperSystemType: any;
  props: {
    [key: string]: any;
  };
}

const initialState: TimeKeeperDeviceState = {
  id: '',
  timeKeeperSystemTypeId: '',
  name: '',
  channel: '',
  type: '',
  timeKeeperSystemType: {},
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const timeKeeperDeviceSlice = createSlice({
  name: 'timeKeeperDevice',
  initialState,
  reducers: {
    setTimeKeeperDevice: (state, action: PayloadAction<Partial<TimeKeeperDeviceState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<TimeKeeperDeviceState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: TimeKeeperDeviceState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setTimeKeeperDevice, resetProps, updateField, updateProps } = timeKeeperDeviceSlice.actions;

export default timeKeeperDeviceSlice.reducer;
